import ClassicCard from './ClassicCard';
/* @ts-ignore */
import { Iconly } from 'react-iconly';
import Button  from './Button';
import React from 'react';
import WithdrawModal from './WithdrawModal';
import Popup from './Popup';
import Dinero from 'dinero.js';
import PulseLoader from 'react-spinners/PulseLoader';

type IProps = {
  loader: boolean;
  title: string;
  value: any;
  value2: any;
  label?: string;
  label2?: string;
  dinero: boolean,
  before?: string;
  after?: string;
  fill?: boolean;
  icon?: string;
  ltr?: boolean;
  withdraw?: boolean;
  otherClass?: string;
  onSucessfulWithdrawRequest: () => void;
};

const BudgetWidget = ({ loader, title, value, value2, label, label2, before, after, icon, ltr, withdraw = false, otherClass, dinero = false, onSucessfulWithdrawRequest}: IProps) => {
  const [isOpen, setIsOpen] = React.useState<boolean>(false);

  return (
    <>
    <ClassicCard
      otherClasses={`px-5 py-4 shadow-card flex flex-row tablet:flex-col tablet:items-start justify-between items-center ${otherClass ? otherClass : ''}`}
    >
      <div className={`flex items-center  ${ltr ? 'flex-row-reverse' : ''}`}>
        {(icon && (
          <div
            className={`flex items-center px-5 h-16 bg-grey-200 text-dark-400 bg-opacity-20 rounded-4xl py-5 mr-3`}
          >
            <Iconly
              name={icon}
              set="curved"
              size={'medium'}
            />
          </div>
        )) ||
          ''}
        <div className="flex flex-col justify-center">
          <p className={`text-lg md:text-sm text-lightGrey dark:text-dark-400`}>{title}</p>
          {!loader ? (
            <h4 className={`flex items-end text-xl text-white flex flex-wrap`}>
              {before && <div className="font-thin">{before}</div>}
              <strong className="font-semibold md:font-bold">
                {dinero && (
                  Dinero({
                    amount: Number(value),
                    precision: 4,
                    currency: 'USD',
                  }).toFormat()
                ) || 
                value
                }
              </strong>
                {/* <p className="text-dark-400 mx-1 text-xs">{label}</p> */}
                {value2 ? 
                    <div className='flex flex-row items-end whitespace-nowrap'>
                      {dinero && value2 && <strong className=" text-dark-300 mx-2"> | </strong>}
                      <strong className="font-semibold md:font-bold warning-text"> 
                      {dinero && value2 && (
                          Dinero({
                            amount: Number(value2),
                            precision: 4,
                            currency: 'USD',
                          }).toFormat()
                        )
                      }
                      </strong>
                      <p className="warning-text text-sm ml-1 font-semibold md:font-bold">{label2}</p>
                    </div>
                  :
                  ''
                }
              {after && <span className="text-lg md:text-sm ml-1">{after}</span>}
            </h4>
          ): (
            <div><PulseLoader color={'#eeeff0'} size={8} loading={true} /></div>
          )}
        </div>
      </div>
      <div className="tablet:mx-auto">
        {(withdraw && (
          <Button className="tablet:mt-7 whitespace-nowrap" onClick={() => setIsOpen(true)} type="submit" color="secondary" fill="outline" fullWidth>
            Request Cash Out
          </Button>
        ))
        ||
        ''}
      </div>
    </ClassicCard>
      {isOpen && (
        <Popup
          title={'Withdraw request'}
          closeAction={() => {
            setIsOpen(false);
          }}
        >
          <WithdrawModal 
            currentBalance={value}
            closeAction={() => {
              setIsOpen(false);
            }} 
            onSucessfulWithdrawRequest={() => {
              onSucessfulWithdrawRequest();
            }}
          />
        </Popup>
      )}
    </>
  );
};
export default BudgetWidget;
